/* eslint-disable @typescript-eslint/naming-convention */
export interface ReferenceTableModel {
	reference_table_name: string;
}
